var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoliquityToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.631923 11.4884L5.90881 2.44226C7.06645 0.457745 9.93385 0.457741 11.0915 2.44226L16.3684 11.4884C17.535 13.4883 16.0924 16 13.777 16H3.22326C0.907889 16 -0.534726 13.4883 0.631923 11.4884ZM8.50015 4.49997C9.05244 4.49997 9.50015 4.94768 9.50015 5.49997V9.99997C9.50015 10.5523 9.05244 11 8.50015 11C7.94787 11 7.50015 10.5523 7.50015 9.99997V5.49997C7.50015 4.94768 7.94787 4.49997 8.50015 4.49997ZM8.50015 14C9.05244 14 9.50015 13.5523 9.50015 13C9.50015 12.4477 9.05244 12 8.50015 12C7.94787 12 7.50015 12.4477 7.50015 13C7.50015 13.5523 7.94787 14 8.50015 14Z",
    fill: "#CA8A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoliquityToken);
export default __webpack_public_path__ + "static/media/noliquity_token.f66376bcbf1836360adf0e20244e2868.svg";
export { ForwardRef as ReactComponent };